import fetchApi from './api';
import {ApiResponse, SearchPaging} from 'models/model';

export const LicenseClassSave = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/License/Save', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const LicenseClassGetPaging = async (data: SearchPaging): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/License/GetPaging', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const LicenseClassGet = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/License/Get', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const LicenseClassGetAll = async (): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/License/GetAll', {
        method: 'POST'
    });
}

export const LicenseClassDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/License/Delete', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};




